export enum DayClassNameEnum {
	isToday = 'is-today',
	isMonth = 'is-month',
	isOutside = 'is-outside',
	isDisabled = 'is-disabled',
}
